export default __webpack_public_path__ + "static/media/mob-menu-toggle.22d071c6.svg";